import React from 'react';

const Game = ({ node, onAnswer }) => {
  return (
    <div className="question-container">
      <h2>{node.text}</h2>
      <div className="answers">
        {Object.keys(node.answers).map((answerText) => (
          <button key={answerText} onClick={() => onAnswer(answerText)}>
            {answerText}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Game;